export default __webpack_public_path__ + "static/media/lining21.37657dd5.jpeg";